<template>
  <div>
    <div class="banner">
      <div class="content">
        <div class="banner-title">O2O定制</div>
        <div class="line" />
        <div class="desc">
          线上线下融合打通，帮助企业为顾客提供全方位一体化的优质消费体验
        </div>
        <div class="btn-wrap">
          <div
            class="btn"
            @click="openModal"
          >免费试用</div>
        </div>
      </div>
    </div>
    <div class="block-o01">
      <div class="sk-block-title">
        <div class="title">全渠道购物场景</div>
      </div>
      <div class="content-01">
        <img src="@/assets/images/solution/O2O-pic-01.png" alt="">
      </div>
    </div>
    <div class="block-o04" style="height: 530px;">
      <div class="sk-block-title">
        <div class="title">线上线下无缝打通</div>
      </div>
      <div class="content-wrap">
        <div class="content-02">
          <div class="item-01">
            <div class="title">移动商城</div>
            <div class="sub-title">APP、小程序、公众号</div>
            <img class="img" src="@/assets/images/solution/O2O-ad-01.png" alt="">
            <div class="item-01-line">
              <img src="@/assets/images/solution/O2O-line.png" alt="">
            </div>
          </div>
          <div class="item-01">
            <div class="title">PC商城</div>
            <img class="img" src="@/assets/images/solution/O2O-ad-02.png" alt="">
            <div class="item-01-line">
              <img src="@/assets/images/solution/O2O-line.png" alt="">
            </div>
          </div>
          <div class="item-01">
            <div class="title">门店智能设备</div>
            <img class="img" src="@/assets/images/solution/O2O-ad-03.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="block-o02" style="padding-top: 88px;">
      <div class="sk-block-title">
        <div class="title">线上线下互通互联</div>
      </div>
      <div class="content-01">
        <img src="@/assets/images/solution/O2O-pic-02.png" alt="">
      </div>
    </div>
    <div class="block-o01">
      <div class="sk-block-title">
        <div class="title">全渠道数字化</div>
      </div>
      <div class="content-03">
        <div class="item-02">
          <img src="@/assets/images/solution/O2O-pic1-01.png" alt="">
        </div>
        <div class="item-02">
          <img src="@/assets/images/solution/O2O-pic1-02.png" alt="">
        </div>
        <div class="item-02">
          <img src="@/assets/images/solution/O2O-pic1-03.png" alt="">
        </div>
        <div class="item-02">
          <img src="@/assets/images/solution/O2O-pic1-04.png" alt="">
        </div>
      </div>
    </div>
    <div class="block-o03">
      <div class="sk-block-title">
        <div class="title">多业态支持</div>
        <div class="sub-title">不管是单店或者连锁店模式，都可完美支持</div>
      </div>
      <div class="content-01">
        <img src="@/assets/images/solution/O2O-pic-03.png" alt="">
      </div>
    </div>
    <div class="block-o01">
      <div class="sk-block-title">
        <div class="title">定制流程</div>
      </div>
      <div class="content-01">
        <img src="@/assets/images/solution/distribute-pic-04.png" alt="">
      </div>
    </div>
    <CarouselItem title="O2O定制" />
    <ConsultForm info-sources="O2O定制" title="我要定制" />
    <TryModal v-if="visible" :visible="visible" info-sources="O2O定制" @cancel="modalClose" />
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.O2OCustom,
  name: 'O2OCustom',
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data: function() {
    return {
      visible: false
    }
  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  background: url("~@/assets/images/solution/O2O_banner.png") no-repeat center;
  background-size: 100% 100%;
  min-width: 1200px;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    text-align: left;
    .banner-title {
      font-size: 48px;
      color: #FFFFFF;
      line-height: 55px;
    }
    .line {
      width: 100px;
      height: 6px;
      background: #28DAFB;
      margin: 16px 0 31px;
    }
    .desc {
      width: 484px;
      height: 101px;
      font-size: 22px;
      color: #FFFFFF;
      line-height: 38px;
    }
    .btn-wrap {
      .btn {
        width: 200px;
        height: 58px;
        line-height: 58px;
        border-radius: 6px;
        border: 1px solid #FFFFFF;
        font-size: 22px;
        color: #FFFFFF;
        cursor: pointer;
        text-align: center;
        margin-top: 47px;
      }
    }
  }
}
.block-o01 {
  background: #fff;
}
.block-o02 {
  background: #F9F9F9;
}
.block-o03 {
  background: #F6FBFF;
}
.block-o04 {
  background: url('~@/assets/images/solution/O2O-bg.png') no-repeat 0 0;
  .sk-block-title .title {
    color: #fff;
  }
}
.content-01 {
  width: 1200px;
  margin: 0 auto;
  padding: 64px 0 80px;
  text-align: center;
}
.content-wrap {
  width: 1200px;
  margin: 35px auto 88px;
  position: relative;
}
.content-02 {
  background: #fff;
  width: 100%;
  padding: 43px 0 84px;
  display: flex;
  justify-content: space-around;
  box-shadow: 0px 2px 21px 0px rgba(0, 0, 0, 0.15);
  .item-01 {
    width: 385px;
    text-align: center;
    color: #595961;
    font-size: 24px;
    font-weight: 600;
    position: relative;
    &-line {
      position: absolute;
      right: 0;
      top: 33px;
    }
    .sub-title {
      font-size: 16px;
      font-weight: 400;
      margin-top: 13px;
      margin-bottom: 42px;
    }
    &:nth-child(2) {
      .img {
        margin-top: 98px;
      }
    }
    &:nth-child(3) {
      .img {
        margin-top: 103px;
      }
    }
  }
}
.content-03 {
  width: 1200px;
  margin: 0 auto;
  padding: 60px 0;
  display: flex;
  justify-content: space-between;
  .item-02 {
    width: 270px;
  }
}
</style>
